import api from '..';
import { IUser } from '../user';

export const phoneVerificationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    sendVerificationCode: builder.mutation<void, { phone_number: string }>({
      query: ({ phone_number }) => ({
        url: `verifications/verify`,
        method: 'POST',
        body: {
          verify: {
            phone_number,
          },
        },
      }),
    }),

    checkVerificationCode: builder.mutation<
      IUser,
      { phone_number: string; code: string }
    >({
      query: ({ phone_number, code }) => ({
        url: `verifications/check_verification`,
        method: 'POST',
        body: {
          verify: {
            phone_number,
            code,
          },
        },
      }),
      invalidatesTags: [{ type: 'User', id: 'Profile' }],
    }),
  }),
});

export const {
  useCheckVerificationCodeMutation,
  useSendVerificationCodeMutation,
} = phoneVerificationApi;
